export default "/_next/static/fonts/SmileScript-dd0712bb75fb4ebd3a2b996970aa22c0.woff";